<div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header" style="background-color: whitesmoke; height: 20%">
      <a class="" rel="studentDetails" href="#" title="payment Details"> </a>
    </div>
  </div>

  <div class="col-md-6 offset-md-3 mt-5">
    <div class="navbar-header">
      <a class="" rel="studentDetails" href="#" title="Student Details">
        <img class="responsive" style="width: 100%; height: auto" src="assets/images/header-1.jpg"/>
      </a>
    </div>

    <section id="header" class="rounded" style="margin-top: 1%; background-color: white; text-align: center; text-emphasis-color: inherit;">
      <strong>Spintronic Technology and Advance Research</strong>
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-xs-12 col-centered" style="align-items: center; text-decoration: underline">
            <strong> PAYMENT DETAILS </strong>
          </div>
        </div>
      </div>
    </section>

    <div class="card" style="margin-top: 1%">

      <div class="card-body">
        <div *ngIf="!myDIV">
          <form [formGroup]="form" style="padding:20px 120px 0px 106px;" (ngSubmit)="Submit()">

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Registration No</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Registration No" formControlName="registrationNo"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['registrationNo'].hasError('required')">Registration No is required.</mat-error>
                <mat-error *ngIf="form.controls['registrationNo'].hasError('pattern')">Invalid Registration No</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Name of Student</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Student Name" formControlName="studentName"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['studentName'].hasError('required')">Student Name is required.</mat-error>
                <mat-error *ngIf="form.controls['studentName'].hasError('pattern')">Invalid Student Name</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Date of Birth</mat-label>
              <div class="form-group" style="display: flex; margin-bottom: -2vh;">
              <input matInput  required (click)="dp3.open()"  style="width: 100px;margin-top: -1.5vh;" 
              [matDatepicker]="dp3" [max]="todayDate" placeholder="Date Of Birth" 
              formControlName="dob" [readonly]="true">
              <mat-datepicker-toggle style="position: relative; margin-top: -12px; margin-left: 40px;" 
              matIconSuffix [for]="dp3"></mat-datepicker-toggle>
              <mat-datepicker #dp3 disabled="false"></mat-datepicker>
              </div>
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-error *ngIf="form.controls['dob'].hasError('required')">Date of Birth is required.</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Father Name</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Father Name" formControlName="fatherName"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['fatherName'].hasError('required')">Father Name is required.</mat-error>
                <mat-error *ngIf="form.controls['fatherName'].hasError('pattern')">Invalid Father Name</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Mobile No</mat-label>
                <input type="text" matInput maxlength="10" minlength="10" placeholder="Mobile No" formControlName="mobileNo"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('required')">Mobile No is required.</mat-error>
                <mat-error *ngIf="form.controls['mobileNo'].hasError('pattern')">Invalid Mobile No</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Email Id</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Email Id" formControlName="emailId"  autocomplete="off" />
                <mat-error *ngIf="form.controls['emailId'].hasError('pattern')">Invalid Email Id</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Course Name</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Course Name" formControlName="courseName"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['courseName'].hasError('required')">Course Name is required.</mat-error>
                <mat-error *ngIf="form.controls['courseName'].hasError('pattern')">Invalid Course Name</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Academic Year</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Academic Year" formControlName="academicYear"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['academicYear'].hasError('required')">Academic Year is required.</mat-error>
                <mat-error *ngIf="form.controls['academicYear'].hasError('pattern')">Invalid Academic Year</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Session</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Session" formControlName="session"  autocomplete="off" required/>
                <mat-error *ngIf="form.controls['session'].hasError('required')">Session is required.</mat-error>
                <mat-error *ngIf="form.controls['session'].hasError('pattern')">Invalid Session</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Course Fee</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Course Fee" formControlName="courseFee"  autocomplete="off" />
                <mat-error *ngIf="form.controls['courseFee'].hasError('pattern')">Invalid Course Fee</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Transportation Fee</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Transportation Fee" formControlName="transportationFee"  autocomplete="off" />
                <mat-error *ngIf="form.controls['transportationFee'].hasError('pattern')">Invalid Transportation Fee</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Examination Fee</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Examination Fee" formControlName="examinationFee"  autocomplete="off" />
                <mat-error *ngIf="form.controls['examinationFee'].hasError('pattern')">Invalid Examination Fee</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Hostel Fee</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Hostel Fee" formControlName="hostelFee"  autocomplete="off" />
                <mat-error *ngIf="form.controls['hostelFee'].hasError('pattern')">Invalid Hostel Fee</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Other Fee</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Other Fee" formControlName="otherFee"  autocomplete="off" />
                <mat-error *ngIf="form.controls['otherFee'].hasError('pattern')">Invalid Other Fee</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label>Enter Other Fee Details</mat-label>
                <input type="text" matInput maxlength="50" placeholder="Other Fee Details" formControlName="otherFeeDetails"  autocomplete="off" />
                <mat-error *ngIf="form.controls['otherFeeDetails'].hasError('pattern')">Invalid Other Fee Details</mat-error>
              </mat-form-field>
            </div>

            <div class="form-group">
              <mat-form-field style="width:100%">
                <mat-label><h4><b>Total Fee</b></h4></mat-label>
                <input type="number" matInput placeholder="Total Fee" formControlName="totalFee" value ={{getTotal()}} autocomplete="off" [readonly]="true" required/>
              </mat-form-field>
            </div>

              <div class="col-md-12" style="display: inline-block;">
          
                <div class="form-group">
                  <label> Captcha</label>
                  <input matInput  onpaste="return false;" onCopy="return false" onCut="return false" placeholder="Enter Captcha"
                     class="captchaFeild"  formControlName="captcha" autocomplete="off"
                    minlength="6" maxlength="6"  onkeyup="this.value = this.value.toUpperCase();"  class="form-control" [ngClass]="{ 'is-invalid': submitted && f.captcha.errors }" style="border: 1px solid black;" required />
                    <div *ngIf="submitted && f.captcha.errors " class="invalid-feedback">
                      <div *ngIf="f.captcha.errors.required">Captcha is required</div>
                      <div *ngIf="f.captcha.errors.incorrectcaptcha && (!f.captcha.errors.required)">Captcha is invalid </div>
                      <div *ngIf="f.captcha.errors.minlength && (!f.captcha.errors.required)">Captcha required of length {{f.captcha.errors.minlength.requiredLength}} and has length {{f.captcha.errors.minlength.actualLength}}  </div>
                    </div>
                 </div>
                 <div id="capt">
                     <span onselectstart="return false" onpaste="return false;" onCopy="return false" onCut="return false" onDrag="return false" onDrop="return false">{{initialCap}}</span>
                     <span style="float: right; cursor: pointer;">
                             <i class="material-icons" (click)="Cap()">refresh</i>
                     </span>
                </div>
                  <div class="form-group">
                          <button [disabled]="loading" (click)="onSubmit()" style="margin-right:30px;" class="btn btn-primary" >
                              <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                              Pay Now
                          </button>
                         
                  </div>
              </div>

          </form>

        </div>
        <div>
          <form
            target="_top"
            #txnForm
            [formGroup]="tranxnForm"
            method="POST"
            action="{{ isgPay_url }}"
          >
            <input
              type="hidden"
              [value]="EncDataField"
              name="EncData"
              formControlName="EncData"
            />
            <input
              type="hidden"
              [value]="MerchantIdField"
              name="MerchantId"
              formControlName="MerchantId"
            />
            <input
              type="hidden"
              [value]="BankIdField"
              name="BankId"
              formControlName="BankId"
            />
            <input
              type="hidden"
              [value]="TerminalIdField"
              name="TerminalId"
              formControlName="TerminalId"
            />
            <input
              type="hidden"
              [value]="VersionField"
              name="Version"
              formControlName="Version"
            />
            <input
              type="hidden"
              [value]="TransactionId"
              name="OrderId"
              formControlName="TransactionId"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
